import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box, Typography, Container, Grid, Paper,
  FormControl, InputLabel, Select, MenuItem,
  Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField,
  Pagination, Stack, CircularProgress, Divider,Card,CardContent,
  Chip
} from '@mui/material';
import { 
  People, 
  AccountBalance ,
   Schedule,
    CheckCircle,
    Cancel,
 AutoGraph  ,RemoveCircleOutline,
 Description,
 PictureAsPdf,
 
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ReportTabs from './PayrollReportTab'; 
import ReportCharts from './ReportChart';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// import { Document, Packer, Paragraph, TextRun, ImageRun } from 'docx';

 import {
  Document,
  Packer,
  Paragraph,
  Table as DocxTable,
  TableRow as DocxTableRow,
  TableCell as DocxTableCell,
  TextRun,
  WidthType,
  ImageRun
} from 'docx';
  
import { saveAs } from 'file-saver';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ReportDashboard = () => {
  const [reportType, setReportType] = useState('tax-summary');
  const [periodType, setPeriodType] = useState('yearly');
  const [year, setYear] = useState(new Date().getFullYear());
  const [quarter, setQuarter] = useState(1);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const currentYear = new Date().getFullYear();
const [financialYear, setFinancialYear] = useState(`${currentYear - 1}-${currentYear}`);
  // const [financialYear, setFinancialYear] = useState(`${new Date().getFullYear()}-${new Date().getFullYear() + 1}`);
  const [employeeId, setEmployeeId] = useState('');
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [employees, setEmployees] = useState([]);
const [exporting, setExporting] = useState(false);  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(30);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch employees for dropdown
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/employees`,{
          headers:{
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          withCredentials: true
        });
        setEmployees(response.data);
      } catch (err) {
        //console.error('Error fetching employees:', err);
      }
    };
    
    fetchEmployees();
  }, []);



  // Reset pagination when report type changes
  useEffect(() => {
    setCurrentPage(1);
    setReportData(null); // Clear previous report data when switching tabs
  }, [reportType]);

  const generateReport = async () => {
    setLoading(true);
    setError(null);
    setCurrentPage(1); // Reset to first page when generating new report
      const token = localStorage.getItem('token'); 
        if (!token) {
          alert("No authentication token found. Please log in.");
          return;
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
    try {
      let params = {};
      
      if (reportType === 'payroll-summary') {
        params = { periodType, year,company_id };
        if (periodType === 'quarterly') params.quarter = quarter;
        if (periodType === 'monthly') params.month = month;
      } else if (reportType === 'tax-summary') {
        params = { periodType, year, financialYear,company_id };
        if (periodType === 'quarterly') params.quarter = quarter;
        if (periodType === 'monthly') params.month = month;
      } else if (reportType === 'investment' || reportType === 'hra') {
        params = { financialYear,company_id };
      } else if (reportType === 'employee-tax') {
        params = { employeeId, financialYear,company_id };
      } else if (reportType === 'cost-center-summary') {
        params = { periodType, year, company_id };
        if (periodType === 'quarterly') params.quarter = quarter;
        if (periodType === 'monthly') params.month = month;
      }
      
      const response = await axios.get(`${API_URL}/api/${reportType}`, { params ,
        headers:{
          Authorization: `Bearer ${token}`
        },
        withCredentials: true
      });
      
      setReportData(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to generate report');
      //console.error('Error generating report:', err);
    } finally {
      setLoading(false);
    }
  };

  // Pagination helper functions
  const getCurrentPageData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  };

  const getTotalPages = (data) => {
    if (!data || !Array.isArray(data)) return 0;
    return Math.ceil(data.length / itemsPerPage);
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
   const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

const generateFilename = (reportType, extension) => {
  const dateStr = getCurrentDate();
  const formattedType = reportType === 'hra' ? 'allowance' : reportType.replace(/-/g, '_');
  return `${formattedType}_${dateStr}.${extension}`;
};

const getReportTitleAndPeriod = (reportType, periodType, year, financialYear, quarter, month) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  let title = '';
  let period = '';
  
  switch (reportType) {
    case 'payroll-summary':
      title = 'Payroll Summary Report';
      if (periodType === 'monthly') {
        period = `${months[month - 1]} ${year}`;
      } else if (periodType === 'quarterly') {
        period = `Q${quarter} ${year}`;
      } else {
        period = `${year}`;
      }
      break;
    case 'tax-summary':
      title = 'Tax Summary Report';
      period = `FY ${financialYear}`;
      break;
    case 'investment':
      title = 'Investment Summary Report';
      period = `FY ${financialYear}`;
      break;
    case 'hra':
      title = 'Allowance Claims Report';
      period = `FY ${financialYear}`;
      break;
    default:
      title = 'Report';
      period = '';
  }
  return { title, period };
};

const fetchAllReportsData = async () => {
  const token = localStorage.getItem('token'); 
  if (!token) {
    throw new Error("No authentication token found. Please log in.");
  }
  const payload = JSON.parse(atob(token.split('.')[1]));
  const company_id = payload.company_id;

  const taxParams = { periodType, year, financialYear, company_id };
  if (periodType === 'quarterly') taxParams.quarter = quarter;
  if (periodType === 'monthly') taxParams.month = month;

  const otherParams = { financialYear, company_id };

  const fetchSingle = async (url, params) => {
    try {
      const res = await axios.get(url, { params, headers: { Authorization: `Bearer ${token}` }, withCredentials: true });
      return res.data?.data || [];
    } catch (err) {
      //console.error(`Failed to fetch from ${url}`, err);
      return [];
    }
  };

  const [taxData, investmentData, hraData] = await Promise.all([
    fetchSingle(`${API_URL}/api/tax-summary`, taxParams),
    fetchSingle(`${API_URL}/api/investment`, otherParams),
    fetchSingle(`${API_URL}/api/hra`, otherParams)
  ]);

  return {
    "tax-summary": taxData,
    "investment": investmentData,
    "hra": hraData
  };
};

const exportToPDF = async () => {
  setLoading(true);
  setExporting('pdf');
  
  try {
    const isTaxOrFinTab = ['tax-summary', 'investment', 'hra'].includes(reportType);
    
    // Create export container
    const exportContainer = document.createElement('div');
    exportContainer.style.position = 'absolute';
    exportContainer.style.left = '-9999px';
    exportContainer.style.width = '900px'; 
    exportContainer.style.padding = '30px';
    exportContainer.style.backgroundColor = 'white';

    // Title header
    const headerDiv = document.createElement('div');
    headerDiv.style.marginBottom = '25px';
    headerDiv.style.textAlign = 'center';
    headerDiv.style.borderBottom = '2px solid #1976d2';
    headerDiv.style.paddingBottom = '15px';
    
    const titleEl = document.createElement('h1');
    titleEl.innerText = isTaxOrFinTab ? 'Tax and Payroll Reports' : getReportTitleAndPeriod(reportType, periodType, year, financialYear, quarter, month).title;
    titleEl.style.margin = '0 0 5px 0';
    titleEl.style.fontSize = '22pt';
    titleEl.style.color = '#1976d2';
    
    const periodEl = document.createElement('h3');
    periodEl.innerText = isTaxOrFinTab ? `Financial Year: ${financialYear}` : getReportTitleAndPeriod(reportType, periodType, year, financialYear, quarter, month).period;
    periodEl.style.margin = '0';
    periodEl.style.fontSize = '14pt';
    periodEl.style.color = '#555';
    
    headerDiv.appendChild(titleEl);
    headerDiv.appendChild(periodEl);
    exportContainer.appendChild(headerDiv);

    // Define field selection per report type
    const fieldConfig = {
      "payroll-summary": [
        { key: "employee_id", label: "Employee ID" },
        { key: "employee_name", label: "Employee Name", transform: (row) => `${row.personal?.firstName ?? ''} ${row.personal?.lastName ?? ''}` },
        { key: "month", label: "Month" },
        { key: "year", label: "Year" },
        { key: "gross_salary", label: "Gross Salary", transform: (row) => row.gross_salary?.toFixed(2) },
        { key: "total_deductions", label: "Total Deductions", transform: (row) => row.total_deductions?.toFixed(2) },
        { key: "net_salary", label: "Net Salary", transform: (row) => row.net_salary?.toFixed(2) },
        { key: "monthly_tax", label: "Tax", transform: (row) => row.monthly_tax?.toFixed(2) },
      ],
      "investment": [
        { key: "employee_id", label: "Employee ID" },
        { key: "employeeName", label: "Name" },
        { key: "financialYear", label: "Year" },
        { key: "category", label: "Category" },
        { key: "status", label: "Status" },
        { key: "reviewComment", label: "Reviewer Comment", transform: (row) => row.reviewComment || 'No Comment' },
      ],
      "hra": [
        { key: "employee_id", label: "Employee ID" },
        { key: "employeeName", label: "Name" },
        { key: "financialYear", label: "Year" },
        { key: "amount", label: "Amount" },
        { key: "purpose", label: "Category" },
        { key: "status", label: "Status" },
        { key: "reviewComment", label: "Reviewer Comment", transform: (row) => row.reviewComment || 'No Comment' },
      ],
      "tax-summary": [
        { key: 'employee_id', label: 'Employee ID' },
        { key: 'employee_name', label: 'Employee Name', transform: (row) => `${row.personal?.firstName ?? ''} ${row.personal?.lastName ?? ''}` },
        { key: 'financial_year', label: 'Financial Year' },
        { key: 'total_tax_payable_old_regime', label: 'Old Regime Tax', transform: (row) => row.total_tax_payable_old_regime?.toFixed(2) },
        { key: 'total_tax_payable_new_regime', label: 'New Regime Tax', transform: (row) => row.total_tax_payable_new_regime?.toFixed(2) },
        { key: 'better_regime', label: 'Better Regime' },
        { key: 'tax_difference_amount', label: 'Tax Difference', transform: (row) => row.tax_difference_amount?.toFixed(2) },
      ],
    };

    let datasets = {};
    if (isTaxOrFinTab) {
      datasets = await fetchAllReportsData();
    } else {
      datasets[reportType] = reportData ? (reportData.data || []) : [];
    }

    const sectionsToRender = isTaxOrFinTab 
      ? [
          { key: 'tax-summary', title: '1. Tax Summary Report' },
          { key: 'investment', title: '2. Investment Summary Report' },
          { key: 'hra', title: '3. Allowance Claims Report' }
        ]
      : [{ key: reportType, title: getReportTitleAndPeriod(reportType, periodType, year, financialYear, quarter, month).title }];

    sectionsToRender.forEach(({ key, title }) => {
      const selectedFields = fieldConfig[key] || [];
      const tableData = datasets[key] || [];

      // Section title
      const secTitleEl = document.createElement('h2');
      secTitleEl.innerText = title;
      secTitleEl.style.marginTop = '25px';
      secTitleEl.style.marginBottom = '10px';
      secTitleEl.style.fontSize = '15pt';
      secTitleEl.style.color = '#333';
      secTitleEl.style.borderBottom = '1px solid #ddd';
      secTitleEl.style.paddingBottom = '5px';
      exportContainer.appendChild(secTitleEl);

      if (selectedFields.length > 0 && tableData.length > 0) {
        const table = document.createElement('table');
        table.style.width = '100%';
        table.style.borderCollapse = 'collapse';
        table.style.marginTop = '10px';
        table.style.marginBottom = '20px';
        
        // Header row
        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        headerRow.style.backgroundColor = '#1976d2';
        
        selectedFields.forEach(field => {
          const th = document.createElement('th');
          th.innerText = field.label;
          th.style.padding = '8px';
          th.style.border = '1px solid #ddd';
          th.style.textAlign = 'left';
          th.style.color = '#ffffff';
          th.style.fontSize = '9.5pt';
          headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        table.appendChild(thead);
        
        // Data rows
        const tbody = document.createElement('tbody');
        tableData.forEach((row, rowIndex) => {
          const tr = document.createElement('tr');
          if (rowIndex % 2 === 1) {
            tr.style.backgroundColor = '#f9f9f9';
          }
          selectedFields.forEach(field => {
            const td = document.createElement('td');
            const val = field.transform ? field.transform(row) : (row[field.key] ?? "");
            td.innerText = String(val);
            td.style.padding = '7px';
            td.style.border = '1px solid #ddd';
            td.style.fontSize = '8.5pt';
            tr.appendChild(td);
          });
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        exportContainer.appendChild(table);
      } else {
        const noDataEl = document.createElement('p');
        noDataEl.innerText = 'No data available for this section.';
        noDataEl.style.fontStyle = 'italic';
        noDataEl.style.color = '#777';
        noDataEl.style.fontSize = '9.5pt';
        exportContainer.appendChild(noDataEl);
      }
    });

    // Clone charts with proper sizing
    const chartContainer = document.getElementById('report-charts');
    if (chartContainer) {
      const activeTabLabel = reportType === 'tax-summary' ? 'Tax Summary Chart' :
                             reportType === 'investment' ? 'Investment Summary Chart' : 'Allowance Claims Chart';
      
      const chartTitleEl = document.createElement('h2');
      chartTitleEl.innerText = isTaxOrFinTab ? `4. ${activeTabLabel}` : 'Visual Analytics';
      chartTitleEl.style.marginTop = '25px';
      chartTitleEl.style.marginBottom = '10px';
      chartTitleEl.style.fontSize = '15pt';
      chartTitleEl.style.color = '#333';
      chartTitleEl.style.borderBottom = '1px solid #ddd';
      chartTitleEl.style.paddingBottom = '5px';
      exportContainer.appendChild(chartTitleEl);

      const chartsClone = chartContainer.cloneNode(true);
      chartsClone.style.width = '100%';
      chartsClone.style.marginTop = '15px';
      chartsClone.style.overflow = 'visible';
      exportContainer.appendChild(chartsClone);
    }

    document.body.appendChild(exportContainer);

    // Wait for rendering
    await new Promise(resolve => setTimeout(resolve, 1500));

    // Generate PDF with better settings
    const canvas = await html2canvas(exportContainer, {
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true,
      scrollX: 0,
      scrollY: 0,
      width: exportContainer.scrollWidth,
      height: exportContainer.scrollHeight,
      backgroundColor: '#ffffff'
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 190; 
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const pageHeight = 287; 
    let heightLeft = imgHeight;
    let position = 10; 

    // Add first page
    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Keep adding pages if we have height left
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight + 10; 
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const outFilename = isTaxOrFinTab ? 'tax_payroll_report' : reportType;
    pdf.save(generateFilename(outFilename, 'pdf'));

  } catch (error) {
    //console.error('PDF export failed:', error);
    setError(error.message || 'Failed to export PDF');
  } finally {
    // Clean up
    const exportContainer = document.querySelector('div[style*="left: -9999px"]');
    if (exportContainer) exportContainer.remove();
    setLoading(false);
    setExporting(false);
  }
};

const exportToWordEditableWithChart = async () => {
  setLoading(true);
  setExporting('word');

  try {
    const isTaxOrFinTab = ['tax-summary', 'investment', 'hra'].includes(reportType);

    // Define field selection per report type
    const fieldConfig = {
      "payroll-summary": [
        { key: "employee_id", label: "Employee ID" },
        { key: "employee_name", label: "Employee Name", transform: (row) => `${row.personal?.firstName ?? ''} ${row.personal?.lastName ?? ''}` },
        { key: "month", label: "Month" },
        { key: "year", label: "Year" },
        { key: "gross_salary", label: "Gross Salary", transform: (row) => row.gross_salary?.toFixed(2) },
        { key: "total_deductions", label: "Total Deductions", transform: (row) => row.total_deductions?.toFixed(2) },
        { key: "net_salary", label: "Net Salary", transform: (row) => row.net_salary?.toFixed(2) },
        { key: "monthly_tax", label: "Tax", transform: (row) => row.monthly_tax?.toFixed(2) },
      ],
      "investment": [
        { key: "employee_id", label: "Employee ID" },
        { key: "employeeName", label: "Name" },
        { key: "financialYear", label: "Year" },
        { key: "category", label: "Category" },
        { key: "status", label: "Status" },
        { key: "reviewComment", label: "Reviewer Comment", transform: (row) => row.reviewComment || 'No Comment' },
      ],
      "hra": [
        { key: "employee_id", label: "Employee ID" },
        { key: "employeeName", label: "Name" },
        { key: "financialYear", label: "Year" },
        { key: "amount", label: "Amount" },
        { key: "purpose", label: "Category" },
        { key: "status", label: "Status" },
        { key: "reviewComment", label: "Reviewer Comment", transform: (row) => row.reviewComment || 'No Comment' },
      ],
      "tax-summary": [
        { key: 'employee_id', label: 'Employee ID' },
        { key: 'employee_name', label: 'Employee Name', transform: (row) => `${row.personal?.firstName ?? ''} ${row.personal?.lastName ?? ''}` },
        { key: 'financial_year', label: 'Financial Year' },
        { key: 'total_tax_payable_old_regime', label: 'Old Regime Tax', transform: (row) => row.total_tax_payable_old_regime?.toFixed(2) },
        { key: 'total_tax_payable_new_regime', label: 'New Regime Tax', transform: (row) => row.total_tax_payable_new_regime?.toFixed(2) },
        { key: 'better_regime', label: 'Better Regime' },
        { key: 'tax_difference_amount', label: 'Tax Difference', transform: (row) => row.tax_difference_amount?.toFixed(2) },
      ],
    };

    let datasets = {};
    if (isTaxOrFinTab) {
      datasets = await fetchAllReportsData();
    } else {
      datasets[reportType] = reportData ? (reportData.data || []) : [];
    }

    const docElements = [
      new Paragraph({
        children: [
          new TextRun({ 
            text: isTaxOrFinTab ? "Tax and Payroll Reports" : getReportTitleAndPeriod(reportType, periodType, year, financialYear, quarter, month).title, 
            bold: true, 
            size: 36,
            color: "1976d2"
          })
        ],
        spacing: { after: 100 },
      }),
      new Paragraph({
        children: [
          new TextRun({ 
            text: isTaxOrFinTab ? `Financial Year: ${financialYear}` : getReportTitleAndPeriod(reportType, periodType, year, financialYear, quarter, month).period, 
            bold: true, 
            size: 20,
            color: "555555"
          })
        ],
        spacing: { after: 400 },
      })
    ];

    const sectionsToRender = isTaxOrFinTab 
      ? [
          { key: 'tax-summary', title: '1. Tax Summary Report' },
          { key: 'investment', title: '2. Investment Summary Report' },
          { key: 'hra', title: '3. Allowance Claims Report' }
        ]
      : [{ key: reportType, title: getReportTitleAndPeriod(reportType, periodType, year, financialYear, quarter, month).title }];

    sectionsToRender.forEach(({ key, title }) => {
      const selectedFields = fieldConfig[key] || [];
      const tableData = datasets[key] || [];

      // Add Section Heading
      docElements.push(
        new Paragraph({
          children: [
            new TextRun({ text: title, bold: true, size: 24, color: "333333" })
          ],
          spacing: { before: 300, after: 200 }
        })
      );

      if (selectedFields.length > 0 && tableData.length > 0) {
        // Create Header Row
        const headerRow = new DocxTableRow({
          children: selectedFields.map((field) =>
            new DocxTableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: field.label, bold: true })],
                }),
              ],
              width: { size: 100 / selectedFields.length, type: WidthType.PERCENTAGE },
            })
          ),
        });

        // Data Rows
        const dataRows = tableData.map((row) =>
          new DocxTableRow({
            children: selectedFields.map((field) => {
              const val = field.transform ? field.transform(row) : (row[field.key] ?? "");
              return new DocxTableCell({
                children: [
                  new Paragraph({
                    children: [new TextRun({ text: String(val) })]
                  })
                ],
                width: { size: 100 / selectedFields.length, type: WidthType.PERCENTAGE },
              });
            }),
          })
        );

        // Add Table to document
        docElements.push(
          new DocxTable({
            rows: [headerRow, ...dataRows],
            width: { size: 100, type: WidthType.PERCENTAGE },
          })
        );
      } else {
        docElements.push(
          new Paragraph({
            children: [
              new TextRun({ text: "No data available for this section.", italic: true, color: "777777" })
            ],
            spacing: { after: 200 }
          })
        );
      }
    });

    // Capture chart image from DOM if present
    const chartElement = document.getElementById("report-charts");
    let chartImageRun = null;

    if (chartElement) {
      try {
        const canvas = await html2canvas(chartElement, { scale: 2 });
        const imageDataURL = canvas.toDataURL("image/png");
        const response = await fetch(imageDataURL);
        const blob = await response.blob();
        const arrayBuffer = await blob.arrayBuffer();

        chartImageRun = new ImageRun({
          data: arrayBuffer,
          transformation: {
            width: 600,
            height: Math.round((600 * canvas.height) / canvas.width),
          },
          type: "png"
        });
      } catch (err) {
        //console.error("Failed to capture chart for Word document:", err);
      }
    }

    if (chartImageRun) {
      const activeTabLabel = reportType === 'tax-summary' ? 'Tax Summary Chart' :
                             reportType === 'investment' ? 'Investment Summary Chart' : 'Allowance Claims Chart';

      docElements.push(
        new Paragraph({
          spacing: { before: 400, after: 200 },
          children: [new TextRun({ text: isTaxOrFinTab ? `4. ${activeTabLabel}` : "Visual Analytics", bold: true, size: 24 })],
        })
      );
      docElements.push(
        new Paragraph({ children: [chartImageRun] })
      );
    }

    // Create Word document
    const doc = new Document({
      sections: [
        {
          children: docElements,
        },
      ],
    });

    const wordBlob = await Packer.toBlob(doc);
    const outFilename = isTaxOrFinTab ? 'tax_payroll_report' : reportType;
    const filename = generateFilename(outFilename, 'docx');
    saveAs(wordBlob, filename);

  } catch (error) {
    //console.error("Failed to export Word document:", error);
  } finally {
    setLoading(false);
    setExporting(false);
  }
};


// const exportToWord = async () => {
//   setLoading(true);
//   setExporting('word');

//   try {
//     // Create a temporary container
//     const exportContainer = document.createElement('div');
//     exportContainer.style.position = 'absolute';
//     exportContainer.style.left = '-9999px';
//     exportContainer.style.width = '1000px';
//     exportContainer.style.padding = '20px';
//     exportContainer.style.backgroundColor = 'white';

//     // Clone report content
//     const reportContent = document.getElementById('report-content');
//     if (!reportContent) throw new Error('Report content not found');

//     const reportClone = reportContent.cloneNode(true);

//     // Show all table rows by removing pagination effects
//     const tables = reportClone.getElementsByTagName('table');
//     for (let table of tables) {
//       const tbody = table.querySelector('tbody');
//       if (tbody) {
//         const rows = tbody.querySelectorAll('tr');
//         rows.forEach(row => {
//           row.style.display = '';
//         });
//       }
//     }

//     // Remove pagination controls if they exist
//     const pagination = reportClone.querySelector('.MuiPagination-root');
//     if (pagination) pagination.remove();

//     exportContainer.appendChild(reportClone);

//     // Clone charts if they exist
//     const chartContainer = document.getElementById('report-charts');
//     if (chartContainer) {
//       const chartsClone = chartContainer.cloneNode(true);
//       chartsClone.style.marginTop = '20px';
//       chartsClone.style.width = '100%';
//       exportContainer.appendChild(chartsClone);
//     }

//     document.body.appendChild(exportContainer);

//     // Add CSS for export
//     const style = document.createElement('style');
//     style.innerHTML = `
//       table {
//         width: 100% !important;
//         border-collapse: collapse !important;
//       }
//       th, td {
//         padding: 8px !important;
//         border: 1px solid #ddd !important;
//         font-size: 10pt !important;
//       }
//       th {
//         background-color: #f2f2f2 !important;
//         font-weight: bold !important;
//       }
//       .MuiPaper-root {
//         box-shadow: none !important;
//         margin-bottom: 15px !important;
//       }
//       .MuiTypography-h6 {
//         font-size: 14pt !important;
//         margin-bottom: 10px !important;
//       }
//     `;
//     exportContainer.appendChild(style);

//     // Wait for rendering
//     await new Promise(resolve => setTimeout(resolve, 1000));

//     // Generate image
//     const canvas = await html2canvas(exportContainer, {
//       scale: 2,
//       logging: false,
//       useCORS: true,
//       allowTaint: true,
//       scrollX: 0,
//       scrollY: 0,
//       width: exportContainer.scrollWidth,
//       height: exportContainer.scrollHeight
//     });

//     const imageData = canvas.toDataURL('image/png');
//     const response = await fetch(imageData);
//     const blob = await response.blob();
//     const arrayBuffer = await blob.arrayBuffer();

//     // Calculate image dimensions
//     const maxWidth = 600; // points (72 points = 1 inch)
//     const aspectRatio = canvas.height / canvas.width;
//     const imageWidth = Math.min(maxWidth, canvas.width);
//     const imageHeight = imageWidth * aspectRatio;

//     // Create Word document
//     const doc = new Document({
//       sections: [{
//         properties: {
//           page: {
//             size: {
//               width: 11906, // A4 width in twentieths of a point
//               height: 16838, // A4 height in twentieths of a point
//               orientation: 'portrait'
//             },
//             margins: {
//               top: 1440, // 1 inch
//               right: 1440,
//               bottom: 1440,
//               left: 1440,
//             }
//           }
//         },
//         children: [
//           new Paragraph({
//             children: [
//               new ImageRun({
//                 data: arrayBuffer,
//                 transformation: {
//                   width: imageWidth,
//                   height: imageHeight,
//                 },
//               }),
//             ],
//           }),
//         ],
//       }],
//     });

//     // Save the document
//     const blobWord = await Packer.toBlob(doc);
//     const filename = generateFilename('docx');
//     saveAs(blobWord, filename);

//   } catch (error) {
//     //console.error('Word export failed:', error);
//     setError('Failed to export Word document. Please try again.');
//   } finally {
//     // Clean up
//     const exportContainer = document.querySelector('div[style*="left: -9999px"]');
//     if (exportContainer) exportContainer.remove();
//     setLoading(false);
//     setExporting(false);
//   }
// };

// Helper function to clone and modify report content
const reportCloneContent = (element) => {
  const clone = element.cloneNode(true);
  
  // Remove pagination controls
  const pagination = clone.querySelector('.MuiPagination-root');
  if (pagination) pagination.remove();
  
  // Show all table rows
  const tables = clone.getElementsByTagName('table');
  for (let table of tables) {
    const tbody = table.querySelector('tbody');
    if (tbody) {
      const rows = tbody.querySelectorAll('tr');
      rows.forEach(row => {
        row.style.display = '';
      });
    }
  }
  
  return clone;
};

// Helper function to add export styles
// const addExportStyles = (element) => {
//   const style = document.createElement('style');
//   style.innerHTML = `
//     table {
//       width: 100% !important;
//       border-collapse: collapse !important;
//       page-break-inside: avoid !important;
//     }
//     th, td {
//       padding: 8px !important;
//       border: 1px solid #ddd !important;
//       font-size: 10pt !important;
//     }
//     th {
//       background-color: #f2f2f2 !important;
//       font-weight: bold !important;
//     }
//     .MuiPaper-root {
//       box-shadow: none !important;
//       margin-bottom: 15px !important;
//     }
//     .MuiTypography-h6 {
//       font-size: 14pt !important;
//       margin-bottom: 10px !important;
//     }
//   `;
//   element.appendChild(style);
// };
  
//   try {
//     // Create a temporary container
//     const exportContainer = document.createElement('div');
//     exportContainer.style.position = 'absolute';
//     exportContainer.style.left = '-9999px';
//     exportContainer.style.width = '1000px';
//     exportContainer.style.padding = '20px';
//     exportContainer.style.backgroundColor = 'white';
    
//     // Clone report content and modify for export
//     const reportContent = document.getElementById('report-content');
//     if (!reportContent) throw new Error('Report content not found');
    
//     const reportClone = reportCloneContent(reportContent);
//     exportContainer.appendChild(reportClone);
    
//     // Clone charts if they exist
//     const chartContainer = document.getElementById('report-charts');
//     if (chartContainer) {
//       const chartsClone = chartContainer.cloneNode(true);
//       chartsClone.style.marginTop = '20px';
//       chartsClone.style.width = '100%';
//       exportContainer.appendChild(chartsClone);
//     }
    
//     document.body.appendChild(exportContainer);
    
//     // Add CSS for export
//     addExportStyles(exportContainer);
    
//     // Wait for rendering
//     await new Promise(resolve => setTimeout(resolve, 1000));
    
//     // Generate image
//     const canvas = await html2canvas(exportContainer, {
//       scale: 2,
//       logging: false,
//       useCORS: true,
//       allowTaint: true,
//       scrollX: 0,
//       scrollY: 0,
//       width: exportContainer.scrollWidth,
//       height: exportContainer.scrollHeight
//     });
    
//     const imageData = canvas.toDataURL('image/png');
//     const response = await fetch(imageData);
//     const blob = await response.blob();
//     const arrayBuffer = await blob.arrayBuffer();
    
//     // Calculate image dimensions
//     const maxWidth = 600; // points (72 points = 1 inch)
//     const aspectRatio = canvas.height / canvas.width;
//     const imageWidth = Math.min(maxWidth, canvas.width);
//     const imageHeight = imageWidth * aspectRatio;
    
//     // Create Word document
//     const doc = new Document({
//       sections: [{
//         properties: {
//           page: {
//             size: {
//               width: 11906, // A4 width in twentieths of a point
//               height: 16838, // A4 height in twentieths of a point
//               orientation: 'portrait'
//             },
//             margins: {
//               top: 1440, // 1 inch
//               right: 1440,
//               bottom: 1440,
//               left: 1440,
//             }
//           }
//         },
//         children: [
//           new Paragraph({
//             children: [
//               new ImageRun({
//                 data: arrayBuffer,
//                 transformation: {
//                   width: imageWidth,
//                   height: imageHeight,
//                 },
//               }),
//             ],
//           }),
//         ],
//       }],
//     });
    
//     // Save the document
//     const blobWord = await Packer.toBlob(doc);
//     const filename = generateFilename('docx');
//     saveAs(blobWord, filename);
    
//   } catch (error) {
//     //console.error('Word export failed:', error);
//     setError('Failed to export Word document. Please try again.');
//   } finally {
//     // Clean up
//     const exportContainer = document.querySelector('div[style*="left: -9999px"]');
//     if (exportContainer) exportContainer.remove();
//     setLoading(false);
//   }
// };



// Helper function to add export styles
const addExportStyles = (element) => {
  const style = document.createElement('style');
  style.innerHTML = `
    table {
      width: 100% !important;
      border-collapse: collapse !important;
      page-break-inside: avoid !important;
    }
    th, td {
      padding: 8px !important;
      border: 1px solid #ddd !important;
      font-size: 10pt !important;
    }
    th {
      background-color: #f2f2f2 !important;
      font-weight: bold !important;
    }
    .MuiPaper-root {
      box-shadow: none !important;
      margin-bottom: 15px !important;
    }
    .MuiTypography-h6 {
      font-size: 14pt !important;
      margin-bottom: 10px !important;
    }
  `;
  element.appendChild(style);
};


  const renderReportControls = () => {
    switch (reportType) {
      case 'payroll-summary':
      case 'cost-center-summary':
      // case 'tax-summary':
        return (
  <Box display="flex" flexWrap="wrap" gap={2}>
    <FormControl margin="normal">
      <InputLabel>Period Type</InputLabel>
      <Select
        label="Period Type"
        value={periodType}
        onChange={(e) => setPeriodType(e.target.value)}
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="monthly">Monthly</MenuItem>
        <MenuItem value="quarterly">Quarterly</MenuItem>
        <MenuItem value="yearly">Yearly</MenuItem>
      </Select>
    </FormControl>

    <FormControl margin="normal">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          views={['year']}
          label="Year"
          value={new Date(year, 0, 1)}
          onChange={(newValue) => setYear(newValue.getFullYear())}
          renderInput={(params) => <TextField {...params} sx={{ minWidth: 120 }} />}
        />
      </LocalizationProvider>
    </FormControl>

    {periodType === 'quarterly' && (
      <FormControl margin="normal" sx={{ minWidth: 150 }}>
        <InputLabel>Quarter</InputLabel>
        <Select
          label="Quarter"
          value={quarter}
          onChange={(e) => setQuarter(e.target.value)}
        >
          <MenuItem value={1}>Q1 (Jan-Mar)</MenuItem>
          <MenuItem value={2}>Q2 (Apr-Jun)</MenuItem>
          <MenuItem value={3}>Q3 (Jul-Sep)</MenuItem>
          <MenuItem value={4}>Q4 (Oct-Dec)</MenuItem>
        </Select>
      </FormControl>
    )}

    {periodType === 'monthly' && (
      <FormControl margin="normal" sx={{ minWidth: 150 }}>
        <InputLabel>Month</InputLabel>
        <Select
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          {[
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ].map((monthName, index) => (
            <MenuItem key={index + 1} value={index + 1}>{monthName}</MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
  </Box>
);

        case 'tax-summary':
        return (
          <>
           {reportType === 'tax-summary' && (
              <FormControl  margin="normal">
                <InputLabel>Financial Year</InputLabel>
                <Select
                label="Financial Year"
                  value={financialYear}
                  sx={{ width: 190, height :46, mb:1}} 
                  onChange={(e) => setFinancialYear(e.target.value)}
                >
                   <MenuItem value={`${year-3}-${year-2}`}>{year-3}-{year-2}</MenuItem>
                   <MenuItem value={`${year-2}-${year-1}`}>{year-2}-{year-1}</MenuItem>
                  <MenuItem value={`${year-1}-${year}`}>{year-1}-{year}</MenuItem>
                  <MenuItem value={`${year}-${year+1}`}>{year}-{year+1}</MenuItem>
                  <MenuItem value={`${year+1}-${year+2}`}>{year+1}-{year+2}</MenuItem>
                </Select>
              </FormControl>
            )}
          </>
        );
        
      case 'investment':
      case 'hra':
        return (
          <FormControl  margin="normal">
            <InputLabel>Financial Year</InputLabel>
            <Select
            label="Finanacial Year"
              value={financialYear}
              sx={{ width: 190, height :46, mb:1}} 
              onChange={(e) => setFinancialYear(e.target.value)}
            >
               <MenuItem value={`${year-3}-${year-2}`}>{year-3}-{year-2}</MenuItem>
               <MenuItem value={`${year-2}-${year-1}`}>{year-2}-{year-1}</MenuItem>
                  <MenuItem value={`${year-1}-${year}`}>{year-1}-{year}</MenuItem>
                  <MenuItem value={`${year}-${year+1}`}>{year}-{year+1}</MenuItem>
                  <MenuItem value={`${year+1}-${year+2}`}>{year+1}-{year+2}</MenuItem>
            </Select>
          </FormControl>
        );
        
   
        
      default:
        return null;
    }
  };
  useEffect(() => {
  if (
   
    reportType === 'tax-summary' ||
    reportType === 'investment' ||
    reportType === 'hra' ||
    reportType === 'cost-center-summary'
  ) {
    generateReport();
  }
}, [financialYear, periodType, year, quarter, month, reportType]);  // triggers when financial year changes


    const renderMetricsCards = () => {
    if (!reportData || !reportData.data) return null;

    switch (reportType) {
      case 'payroll-summary':
        const payrollData = reportData.data || [];
        const zeroTaxCount = payrollData.filter(item => (item.monthly_tax || 0) === 0).length;
        const taxApplicableCount = payrollData.length - zeroTaxCount;
        
        return (
          <Grid container spacing={3} sx={{ mb: 3 }}>
           <Grid item xs={12} md={4}>
  <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {payrollData.length}
        </Typography>
        <People sx={{ fontSize: 40, color: '#1976d2', mr: 2 }} />
        
      </Box>
      <Typography color="#1976d2" variant="h6">
        Total Employees
      </Typography>
    </CardContent>
  </Card>
</Grid>

<Grid item xs={12} md={4}>
  <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#f57c00', fontWeight: 'bold' }}>
          {zeroTaxCount}
        </Typography>
        <RemoveCircleOutline sx={{ fontSize: 40, color: '#f57c00', mr: 2 }} />
        
      </Box>
      <Typography color="#f57c00" variant="h6">
        Zero Tax Applicable
      </Typography>
    </CardContent>
  </Card>
</Grid>

<Grid item xs={12} md={4}>
  <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
         <Typography variant="h4" component="div" sx={{ color: '#388e3c', fontWeight: 'bold' }}>
          {taxApplicableCount}
        </Typography>
        <AccountBalance sx={{ fontSize: 40, color: '#388e3c', mr: 2 }} />
       
      </Box>
      <Typography color="#388e3c" variant="h6">
        Tax Applicable 
      </Typography>
    </CardContent>
  </Card>
</Grid>
          </Grid>
        );

      case 'tax-summary':
        const taxData = reportData.data || [];
        const oldRegimeCount = taxData.filter(item => item.better_regime === 'Old Regime').length;
        const newRegimeCount = taxData.filter(item => item.better_regime === 'New Regime').length;
        
        return (
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={4}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {taxData.length}
        </Typography>
        <People sx={{ fontSize: 40, color: '#1976d2', mr: 2 }} />
        
      </Box>
                  <Typography color="#1976d2">
                    Total Employees
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
         <Typography variant="h4" component="div" sx={{ color: '#f57c00', fontWeight: 'bold' }}>
          {oldRegimeCount}
        </Typography>
        <AccountBalance sx={{ fontSize: 40, color: '#f57c00', mr: 2 }} />
       
      </Box>
                  <Typography color="#f57c00">
                    Old Regime 
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
             <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#388e3c', fontWeight: 'bold' }}>
          {newRegimeCount}
        </Typography>
        <AutoGraph   sx={{ fontSize: 40, color: '#388e3c', mr: 2 }} />
        
      </Box>

                  <Typography color="#388e3c">
                    New Regime
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        );

      case 'investment':
        const investmentData = reportData.data || [];
        const approvedCount = investmentData.filter(item => item.status === 'Approved').length;
        const pendingCount = investmentData.filter(item => item.status === 'Pending').length;
        const rejectedCount = investmentData.filter(item => item.status === 'Rejected').length;
        
        return (
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {investmentData.length}
        </Typography>
        <People sx={{ fontSize: 40, color: '#1976d2', mr: 2 }} />
        
      </Box>
                  <Typography color="#1976d2">
                    Total Investment
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#f57c00', fontWeight: 'bold' }}>
          {pendingCount}
        </Typography>
        <Schedule sx={{ fontSize: 40, color: '#f57c00', mr: 2,opacity:0.8 }} />
        
      </Box>

                  <Typography color="#f57c00">
                    Pending
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: 'green', fontWeight: 'bold' }}>
          {approvedCount}
        </Typography>
        <CheckCircle sx={{ fontSize: 40, color: 'green', mr: 2,opacity:0.8 }} />
        
      </Box>

                  <Typography color="green">
                    Approved
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: 'red', fontWeight: 'bold' }}>
          {rejectedCount}
        </Typography>
        <Cancel sx={{ fontSize: 40, opacity: 0.8,mr: 2, color:"red"}} />
        
      </Box>
                  <Typography color="red">
                    Rejected
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        );

      case 'hra':
        const hraData = reportData.data || [];
        const hraApprovedCount = hraData.filter(item => item.status === 'approved').length;
        const hraPendingCount = hraData.filter(item => item.status === 'pending').length;
        const hraRejectedCount = hraData.filter(item => item.status === 'rejected').length;
        
        return (
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={3}>
                <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
         <Typography variant="h4" component="div" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {hraData.length}
        </Typography>
        <People sx={{ fontSize: 40, color: '#1976d2', mr: 2 }} />
       
      </Box>
                  <Typography color="text.secondary">
                    Total Claims
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: '#f57c00', fontWeight: 'bold' }}>
          {hraPendingCount}
        </Typography>
        <Schedule sx={{ fontSize: 40, color: '#f57c00', mr: 2 }} />
        
      </Box>
                  
                  <Typography color="#f57c00">
                    Pending
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: 'green', fontWeight: 'bold' }}>
          {hraApprovedCount}
        </Typography>
        <CheckCircle sx={{ fontSize: 40, color: 'green', mr: 2 }} />
        
      </Box>

                  <Typography color="green">
                    Approved
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <Card sx={{border: "2px solid", borderColor: "grey.300", boxShadow: 4}}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1,justifyContent: 'space-between' }}>
        <Typography variant="h4" component="div" sx={{ color: 'red', fontWeight: 'bold' }}>
          {hraRejectedCount}
        </Typography>
        <Cancel sx={{ fontSize: 40, color: 'red', mr: 2 }} />
        
      </Box>
                  <Typography color="red">
                    Rejected
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  };

  const renderPaginationInfo = (totalItems) => {
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex = Math.min(currentPage * itemsPerPage, totalItems);
    
    return (
      <Typography variant="body2" color="textSecondary">
        Showing {startIndex}-{endIndex} of {totalItems} records
      </Typography>
    );
  };

  const renderReportData = () => {
    if (loading) {
      return (
        <Box id='report-content' sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      );
    }
    
    if (error) {
      return (
        <Paper sx={{ p: 3 }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      );
    }
    
    if (!reportData) return null;
    
    switch (reportType) {
      case 'payroll-summary':
        const payrollData = reportData.data || [];
        const currentPayrollData = getCurrentPageData(payrollData);
        const totalPayrollPages = getTotalPages(payrollData);
        
        return (
          <Box>
            {/* {renderMetricsCards()} */}
         
          <Box id='report-content'>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
              {renderPaginationInfo(payrollData.length)}
              <Typography variant="h6">Payroll Summary Report</Typography>
            </Stack>
            
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee ID</TableCell>
                    <TableCell>Employee Name</TableCell>
                    <TableCell>Month</TableCell>
                    <TableCell>Year</TableCell>
                    <TableCell>Gross Salary</TableCell>
                    <TableCell>Total Deductions</TableCell>
                    <TableCell>Net Salary</TableCell>
                    <TableCell>Tax</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentPayrollData.map((row) => (
                    <TableRow key={`${row.employee_id}-${row.month}-${row.year}`}>
                      <TableCell>{row.employee_id}</TableCell>
                      <TableCell>{`${row.personal?.firstName} ${row.personal?.lastName}`}</TableCell>
                      <TableCell>{row.month}</TableCell>
                      <TableCell>{row.year}</TableCell>
                      <TableCell>{row.gross_salary?.toFixed(2)}</TableCell>
                      <TableCell>{row.total_deductions?.toFixed(2)}</TableCell>
                      <TableCell>{row.net_salary?.toFixed(2)}</TableCell>
                      <TableCell>{row.monthly_tax?.toFixed(2)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            
            {totalPayrollPages > 1 && (
              <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
                <Pagination
                  count={totalPayrollPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            )}
          </Box>
          </Box>
        );
        
      case 'tax-summary':
        const taxData = reportData.data || [];
        const currentTaxData = getCurrentPageData(taxData);
        const totalTaxPages = getTotalPages(taxData);
        
        return (
          <Box>
            {/* {renderMetricsCards()} */}
          
          <Box id='report-content'>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
              {renderPaginationInfo(taxData.length)}
              <Typography variant="h6">Tax Summary Report</Typography>
            </Stack>
            
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee ID</TableCell>
                    <TableCell>Employee Name</TableCell>
                    <TableCell>Financial Year</TableCell>
                    <TableCell>month</TableCell>
                    <TableCell>Old Regime Tax</TableCell>
                    <TableCell>New Regime Tax</TableCell>
                    <TableCell>Better Regime</TableCell>
                    <TableCell>Tax Difference</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentTaxData.map((row) => (
                    <TableRow key={`${row.employee_id}-${row.financial_year}`}>
                      <TableCell>{row.employee_id}</TableCell>
                      <TableCell>{`${row.personal?.firstName} ${row.personal?.lastName}`}</TableCell>
                      <TableCell>{row.financial_year}</TableCell>
                      <TableCell>{row.month}</TableCell>
                      <TableCell>{row.total_tax_payable_old_regime?.toFixed(2)}</TableCell>
                      <TableCell>{row.total_tax_payable_new_regime?.toFixed(2)}</TableCell>
                      <TableCell>{row.better_regime}</TableCell>
                      <TableCell>{row.tax_difference_amount?.toFixed(2)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            
            {totalTaxPages > 1 && (
              <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
                <Pagination
                  count={totalTaxPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            )}
          </Box>
          </Box>
        );
        
      case 'investment':
        const investmentData = reportData.data || [];
        const currentInvestmentData = getCurrentPageData(investmentData);
        const totalInvestmentPages = getTotalPages(investmentData);
        
        return (
          <Box>
            {/* {renderMetricsCards()} */}
         
          <Box id='report-content'>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
              {renderPaginationInfo(investmentData.length)}
              <Typography variant="h6">Investment Summary Report</Typography>
            </Stack>
            
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee ID</TableCell>
                    <TableCell>Employee Name</TableCell>
                    <TableCell>Financial Year</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Reviewer Comment</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentInvestmentData.map((row) => {
                    const data = row?.dataValues || row;
                    if (!data) return null;
                    
                    
                    return (
                      <TableRow key={`${row.employee_id}-${row.financial_year}`}>
                        <TableCell>{row.employee_id}</TableCell>
                        <TableCell>{row.employeeName}</TableCell>
                        <TableCell>{row.financialYear}</TableCell>
                        <TableCell>{row.category}</TableCell>
                        <TableCell><Chip
    label={row.status}
    color={
      row.status === 'Approved'
        ? 'success'
        : row.status === 'Rejected'
        ? 'error'
        : row.status === 'Pending'
        ? 'warning'
        : 'default'
    }
    variant="outlined"
  /></TableCell>
                       <TableCell>{row.reviewComment || 'No Comments'}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            
            {totalInvestmentPages > 1 && (
              <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
                <Pagination
                  count={totalInvestmentPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            )}
          </Box>
          </Box>
        );
        
      case 'hra':
        const hraData = reportData.data || [];
        const currentHraData = getCurrentPageData(hraData);
        const totalHraPages = getTotalPages(hraData);
        
        return (
          <Box>
            {/* {renderMetricsCards()} */}
          
          <Box id='report-content'>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
              {renderPaginationInfo(hraData.length)}
              <Typography variant="h6">Allowance Claims Report</Typography>
            </Stack>
            
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee ID</TableCell>
                    <TableCell>Employee Name</TableCell>
                    <TableCell>Financial Year</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Reviewer Comment</TableCell>
                   
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentHraData.map((row) => (
                    <TableRow key={`${row.employee_id}-${row.financial_year}`}>
                      <TableCell>{row.employee_id}</TableCell>
                      <TableCell>{row.employeeName}</TableCell>
                      <TableCell>{row.financialYear}</TableCell>
                      <TableCell>{row.amount}</TableCell>
                      <TableCell>{row.purpose}</TableCell>
                      <TableCell><Chip
    label={row.status}
    color={
      row.status === 'Approved'
        ? 'success'
        : row.status === 'Rejected'
        ? 'error'
        : row.status === 'Pending'
        ? 'warning'
        : 'default'
    }
    variant="outlined"
  /></TableCell>
                      <TableCell>{row.reviewComment || "No Comment"}</TableCell>
              
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            
            {totalHraPages > 1 && (
              <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
                <Pagination
                  count={totalHraPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                />
              </Stack>
            )}
          </Box>
          </Box>
        );
        
     
        
      case 'cost-center-summary':
        const ccData = reportData.data || [];
        const currentCCData = getCurrentPageData(ccData);
        const totalCCPages = getTotalPages(ccData);
        
        return (
          <Box>
            <Box id='report-content'>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                {renderPaginationInfo(ccData.length)}
                <Typography variant="h6">Cost Center Summary Report</Typography>
              </Stack>
              
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold' }}>Cost Center Name</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Code</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Employee Count</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Base Salary (INR)</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">HRA (INR)</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Total Deductions (INR)</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Gross Salary (INR)</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Net Salary (INR)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentCCData.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>
                          <Chip label={row.code} size="small" variant="outlined" color="primary" />
                        </TableCell>
                        <TableCell align="right">{row.employeeCount}</TableCell>
                        <TableCell align="right">{(row.totalBaseSalary || 0).toLocaleString('en-IN')}</TableCell>
                        <TableCell align="right">{(row.totalHRA || 0).toLocaleString('en-IN')}</TableCell>
                        <TableCell align="right">{(row.totalDeductions || 0).toLocaleString('en-IN')}</TableCell>
                        <TableCell align="right">{(row.totalGrossSalary || 0).toLocaleString('en-IN')}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                          {(row.totalNetSalary || 0).toLocaleString('en-IN')}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              
              {totalCCPages > 1 && (
                <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
                  <Pagination
                    count={totalCCPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                  />
                </Stack>
              )}
            </Box>
          </Box>
        );

      default:
        return null;
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2, paddingTop:4, mb: 4,border: "2px solid", borderColor: "grey.300", boxShadow: 4 }}>

      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center" 
        mb={3}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Tax and Payroll Reports
        </Typography>
        {reportData && (
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              onClick={exportToWordEditableWithChart}
              startIcon={<Description/>}
              sx={{
                padding: "10px 16px",
                fontSize: "0.9rem",
                textTransform: "none",
                borderRadius: "8px",
                borderWidth: 2,
                borderColor: "primary",
                color: "primary",
                "&:hover": {
                  borderColor: "#1d4ed8",
                  bgcolor: "#eff6ff",
                },
              }}
            >
              Export to Word
            </Button>
            <Button
              variant="outlined"
              onClick={exportToPDF}
              startIcon={<PictureAsPdf />}
              sx={{
                padding: "10px 16px",
                fontSize: "0.9rem",
                textTransform: "none",
                borderRadius: "8px",
                borderWidth: 2,
                borderColor: "primary",
                color: "primary",
                "&:hover": {
                  borderColor: "#1d4ed8",
                  bgcolor: "#eff6ff",
                },
              }}
            >
              Export to PDF
            </Button>
          </Box>
        )}
      </Box>

      {/* Controls Row */}
      <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
        {renderReportControls()}
      </Box>
      
      {/* Tabs Section */}
      <Paper sx={{ mb: 3 }}>
        <ReportTabs reportType={reportType} setReportType={setReportType} />
        
      </Paper>

      {/* Controls Section */}
      {/* <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Report Configuration
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
          </Grid>
          
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={generateReport}
              disabled={loading}
              sx={{ mr: 2 }}
            >
              {loading ? 'Generating...' : 'Generate Report'}
            </Button>
            
            
          </Grid>
        </Grid>
      </Paper> */}
      {reportData && !loading && !error && (
        <Box>
          {renderMetricsCards()}
        </Box>)}

      
     
     {reportData && !loading && !error && (
  <Box id="report-charts" sx={{ mt: 3 }}>
    <ReportCharts 
      reportType={reportType} 
      reportData={reportData} 
    />
  </Box>
)}
      {renderReportData()}

      
    </Container>
  );
};

export default ReportDashboard;